const loaderConfig = require('./config.json');

// Add fixed element to DOM to warn if any overrides are present
const addOverrideWarning = (message, consoleMsg) => {
  console.warn("Override detected: '" + consoleMsg);

  const callback = () => {
    const warningsContainerId = 'sn-session-override-warnings';
    let warningsContainer = document.getElementById(warningsContainerId);
    if (!warningsContainer) {
      warningsContainer = document.createElement('div');
      warningsContainer.id = warningsContainerId;
      warningsContainer.setAttribute('style', 'background: darkred; position: fixed; bottom: 0; left: 0; right: 0; z-index: 1000000; padding: 0.25em; color: white; font-family: monospace; font-size: small;');
      warningsContainer.innerHTML = '(!) Session overrides:';
      warningsContainer.addEventListener('mouseover', () => (warningsContainer.style.opacity = '0.20'));
      warningsContainer.addEventListener('mouseout', () => (warningsContainer.style.opacity = '1'));
      document.body.appendChild(warningsContainer);
    }
    warningsContainer.innerHTML += message;
  };

  const handleReadyState = () => {
    document.removeEventListener('DOMContentLoaded', handleReadyState, false);
    callback();
  };

  const readyState = document.readyState;
  if (readyState === 'interactive' || readyState === 'complete') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', handleReadyState, false);
  }
};

/**
 * Initialize configuration
 * Choose config based on loader configuration, i.e. base or experiments
 * Override configuration with optional debug configurations
 *
 * @returns {boolean} true if loader should continue, false if loader should abort
 */
module.exports = {
  init: () => {
    try {
      const snConfig = (window._snigelConfig ||= {});
      const expStorageItemName = '_sn_exp';
      const expStorage = window.localStorage;

      // Session override settings
      const overrideConfig = JSON.parse(window.sessionStorage.getItem('snSessionOverrides'));

      // The overriding loader is the loader set in the override and created by the original loader
      const isTheOverridingLoader = overrideConfig && overrideConfig.loaderUrl && overrideConfig.loaderUrl === document.currentScript.src;

      if (!isTheOverridingLoader || overrideConfig.loaderSettingsOverride) {
        // Copy loader config to _snigelConfig (skip experiments)
        for (const property in loaderConfig) {
          if (property != 'exp') {
            snConfig[property] = loaderConfig[property];
          }
        }

        // Read and parse previous experiment choice
        let [storedCfgVer, storedExpId] = (expStorage.getItem(expStorageItemName) || '').split(';');

        // Choose experiment
        if (loaderConfig.exp || (storedCfgVer === 'DEV_EXP' && storedExpId > 1)) {
          if (loaderConfig.exp) {
            if (loaderConfig.cfgVer && storedCfgVer != loaderConfig.cfgVer) {
              // If the configuration version has changed, reset the stored experiment ID
              storedCfgVer = loaderConfig.cfgVer;
              storedExpId = undefined;
            } else if (storedExpId != undefined && !loaderConfig.exp.some(exp => storedExpId == exp.id)) {
              // Loader exp has precedence, so forget the stored experiment if a loader exp is declared but it is not matching one of them
              storedExpId = undefined;
            }
          }

          // Select the right version, by using the stored experiment or the experiment frequency
          const expRand = Math.random();
          if (
            !(loaderConfig.exp || []).some(exp => {
              if (storedExpId == exp.id || (storedExpId == undefined && expRand < exp.freq)) {
                // Store selected experiment id
                storedExpId = exp.id;

                // Append experiment id as query string to adengine request
                const devOrAdopsExp = exp.devExp ? 'devExp' : 'exp';
                const expQueryString = devOrAdopsExp + '=' + storedExpId;
                const adnginQueryString = exp.settings.adngin.queryParameters;
                exp.settings.adngin.queryParameters = adnginQueryString ? adnginQueryString + '&' + expQueryString : expQueryString;

                // Use experiment settings as active loader settings
                snConfig.settings = exp.settings;
                return true;
              }
              return false;
            })
          ) {
            if (!loaderConfig.exp && storedCfgVer === 'DEV_EXP') {
              // Resuming a devExp choice no longer declared as a loader experiment
              // (either an ARMS-level sticky devExp, or this loader experiment has
              // concluded). Forward it once as devExp, then stop tracking it so we
              // don't resend a stale choice on every future page load.
              const expQueryString = 'devExp=' + storedExpId;
              const adnginQueryString = loaderConfig.settings.adngin.queryParameters;
              loaderConfig.settings.adngin.queryParameters = adnginQueryString ? adnginQueryString + '&' + expQueryString : expQueryString;
              expStorage.removeItem(expStorageItemName);
            } else {
              storedExpId = 0;
              expStorage.setItem(expStorageItemName, storedCfgVer + ';' + storedExpId);
            }
          } else {
            // Remember choice
            expStorage.setItem(expStorageItemName, storedCfgVer + ';' + storedExpId);
          }
        } else {
          // Delete local storage item when there is no active experiment
          expStorage.removeItem(expStorageItemName);
        }
      }

      if (overrideConfig) {
        // Loader override, add a new loader and abort this one
        const loaderUrl = overrideConfig.loaderUrl;
        if (loaderUrl) {
          if (!isTheOverridingLoader) {
            addOverrideWarning(' (Loader overriden) ', "Loader'.");
            const scriptTag = document.createElement('script');
            scriptTag.src = loaderUrl;
            scriptTag.async = true;
            document.head.appendChild(scriptTag);

            // abort script
            return false;
          }
        }

        const products = overrideConfig.products;
        const adEngineCoreConfig = overrideConfig.adEngineCoreConfig;

        if (products && typeof products === 'object' && !Array.isArray(products)) {
          Object.keys(products).forEach(product => {
            const productOverride = products[product];
            const productSettings = snConfig.settings[product];
            const message = productOverride.message || '';
            productSettings.url = productOverride.url;
            productSettings.queryParameters = productOverride.queryParameters;
            addOverrideWarning(' (' + product + ', ' + message + ')', product + "': " + message);
          });
        }
        if (adEngineCoreConfig) {
          snConfig.adEngineCoreConfigOverride = adEngineCoreConfig;
          addOverrideWarning(' (AdEngine coreConfig overriden) ', "AdEngine coreConfig'.");
        }
      }
    } catch (e) {}
    return true;
  },

  get: () => window._snigelConfig || {}
};
